import { Component, EventEmitter, Input, Output } from '@angular/core';
import { buildButtonClasses, type ButtonVariant } from '../button/button-classes.util';
import {
  defaultActionIconLabel,
  type ActionIconName,
  type IconButtonDensity,
} from '../icons/action-icon';

@Component({
  selector: 'app-icon-button',
  template: `
    <button
      type="button"
      [disabled]="disabled || loading"
      [attr.aria-label]="resolvedLabel"
      [attr.title]="title || resolvedLabel"
      [class]="buttonClasses"
      (click)="onClick.emit($event)"
    >
      <app-spinner *ngIf="loading" size="sm"></app-spinner>
      <app-action-icon *ngIf="!loading" [name]="name" [density]="density"></app-action-icon>
    </button>
  `,
  styleUrls: ['../icons/icon-button.scss'],
  host: {
    class: 'tt-icon-btn-host',
    '[class.tt-icon-btn-host--toolbar]': 'density === "toolbar"',
    '[class.tt-icon-btn-host--row]': 'density === "row"',
  },
})
export class IconButtonComponent {
  @Input() name: ActionIconName = 'add';
  @Input() variant: ButtonVariant = 'secondary';
  /** Empty follows context: 40px in the page header, 32px elsewhere. */
  @Input() density: IconButtonDensity = '';
  /** Overrides the Czech default for `name` when set. */
  @Input() ariaLabel = '';
  @Input() title = '';
  @Input() disabled = false;
  @Input() loading = false;
  @Output() onClick = new EventEmitter<MouseEvent>();

  get resolvedLabel(): string {
    const custom = this.ariaLabel.trim();
    return custom || defaultActionIconLabel(this.name);
  }

  get buttonClasses(): string {
    return `${buildButtonClasses({
      variant: this.variant,
      size: 'sm',
      iconOnly: true,
    })} shrink-0`;
  }
}
